import CustomerShipmentsApiV2 from 'api/v2/admins/customer-shipments-api-v2'
import TitlePage from 'components/atoms/title-page'
import React, { useState, useEffect } from 'react'
import { useParams, useLocation } from 'react-router'
import { Alert, Card,  CardBody } from 'reactstrap'
import CustomerOrderShipmentAddressForm from 'domains/customer-order/organisms/shipment-address-form'
import { useHistory } from 'react-router-dom'
import { ALERT_TYPES } from 'constants/alert-constants'
import PropTypes from 'prop-types'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CustomerOrderShipmentAddressEditPage = ({ pageUtils }) => {
  const [ address, setAddress ]           = useState({})
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const { id }                            = useParams()
  const location                          = useLocation()
  const history                           = useHistory()

  useEffect(() => {
    const {
      destination_street_address,
      destination_provinsi,
      destination_kota,
      destination_kecamatan,
      destination_kelurahan,
      destination_kode_pos,
      destination_note
    } = location.state

    setAddress({
      street_address : destination_street_address,
      province       : destination_provinsi,
      city           : destination_kota,
      district       : destination_kecamatan,
      sub_district   : destination_kelurahan,
      postal_code    : destination_kode_pos,
      note           : destination_note
    })
  }, [ location.state ])

  const handleUpdateShippingAddress = (values) => {
    setIsSubmitting(true)
    CustomerShipmentsApiV2.update_address(id, values).then(() => {
      setIsSubmitting(false)
      pageUtils.setAlertMsg('Sucessfully update shipping address!', ALERT_TYPES.SUCCESS)
      setTimeout(() => history.goBack(), 2000)
    }).catch((error) => {
      setIsSubmitting(false)
      pageUtils.setApiErrorMsg(error.response.data)
    })
  }

  return (
    <>
      <TitlePage mainTitle={ 'Shipping Address' } subTitle='Edit' />
      <Alert color='warning'>
        <i className='fas fa-info-circle mr-2' />
        <span>Hanya ubah alamat di shipment. Ubahan alamat di shipment tidak akan ubah alamat Customer dan Shipping Cost.</span>
      </Alert>
      <Card>
        <CardBody>
          <CustomerOrderShipmentAddressForm
            handleSubmit={ handleUpdateShippingAddress }
            address={ address }
            isSubmitting={ isSubmitting }
          />
        </CardBody>
      </Card>
    </>
  )
}

CustomerOrderShipmentAddressEditPage.propTypes    = propTypes
CustomerOrderShipmentAddressEditPage.defaultProps = defaultProps

export default CustomerOrderShipmentAddressEditPage
